'use strict';

/**
 * Pict-Provider-ChecklistAPI
 * --------------------------
 * Browser-side client for the plansheet checklist endpoints. Manages the checklist COLLECTION (list a
 * Work Item's shared checklists or the signed-in user's private ones, create, rename, delete) and the
 * items inside one checklist. Tenancy and the private/shared privacy check are enforced server-side, so
 * the client never sends IDCustomer or trusts itself for access.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'ChecklistAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderChecklistAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	_get(pPath)
	{
		return libFrameworkClient.getJSON(this.fable, this._url(pPath)).catch(() => null);
	}

	_post(pPath, pBody)
	{
		return libFrameworkClient.postJSON(this.fable, this._url(pPath), pBody || {}).catch(() => null);
	}

	_del(pPath)
	{
		return libFrameworkClient.delJSON(this.fable, this._url(pPath)).then(() => true).catch(() => false);
	}

	// ---- the checklist collection ----
	listMine() { return this._get('Checklists/Mine').then((pBody) => (pBody && pBody.Checklists) || []).catch(() => []); }
	listForOwner(pOwnerType, pIDOwner) { return this._get('Checklists/ForOwner/' + encodeURIComponent(pOwnerType) + '/' + encodeURIComponent(pIDOwner)).then((pBody) => (pBody && pBody.Checklists) || []).catch(() => []); }
	create(pDraft) { return this._post('Checklist/New', pDraft).then((pBody) => (pBody && pBody.Checklist) || null); }
	rename(pID, pTitle) { return this._post('Checklist/' + encodeURIComponent(pID) + '/Rename', { Title: pTitle }); }
	remove(pID) { return this._del('Checklist/' + encodeURIComponent(pID)); }

	// ---- one checklist's items ----
	get(pID) { return this._get('Checklist/' + encodeURIComponent(pID)).then((pBody) => pBody || { Checklist: null, Items: [] }).catch(() => ({ Checklist: null, Items: [] })); }
	createItem(pID, pDraft) { return this._post('Checklist/' + encodeURIComponent(pID) + '/Item', pDraft).then((pBody) => (pBody && pBody.Item) || null); }
	updateItem(pItemID, pPatch) { return this._post('ChecklistItem/' + encodeURIComponent(pItemID) + '/Update', pPatch); }
	deleteItem(pItemID) { return this._del('ChecklistItem/' + encodeURIComponent(pItemID)); }
}

module.exports = PictProviderChecklistAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
